import { getSmsClient } from '@/services/sms'

const smsAxios = getSmsClient()
const baseEndpoint = '/metabase-dashboard-link'

export const get = async () => {
  let response = await smsAxios({
    method: 'GET',
    url: `${baseEndpoint}`,
  })

  response.data.data?.forEach((val) => {
    val['can_edit'] = true
    val['can_delete'] = true
  })

  response.data.total_count += 1

  return response?.data
}

export const show = async (id) => {
  const response = await smsAxios({
    method: 'GET',
    url: `${baseEndpoint}/${id}`,
  })
  let result = response?.data
  result['can_edit'] = true
  result['can_delete'] = true

  return result
}

export const deleteSingle = async (id) => {
  let response
  try {
    const res = await smsAxios({
      method: 'DELETE',
      url: `${baseEndpoint}/${id}`,
    })
    response = res
  } catch (error) {
    response = error?.response?.data
  }

  return response
}

export const deleteMany = async (ids) => {
  const _ids = ids.ids ?? ids
  const responses = await Promise.all(_ids?.map((id) => deleteSingle(id)))
  return responses.map((response) => response)
}

export const store = async (data) => {
  const response = await smsAxios({
    method: 'POST',
    url: `${baseEndpoint}`,
    data: {
        dashboard_name: data.dashboard_name,
        dashboard_link: data.dashboard_link
    },
  })

  return response?.data
}

export const update = async (id, data) => {
  const response = await smsAxios({
    method: 'PATCH',
    url: `${baseEndpoint}/${id}`,
    data: {
        dashboard_name: data.dashboard_name,
        dashboard_link: data.dashboard_link
    },
  })

  return response?.data
}

export const updateSorting = async (id, data) => {
  const response = await smsAxios({
    method: 'PATCH',
    url: `${baseEndpoint}/${id}`,
    data: {
        dashboard_name: data.dashboard_name,
        dashboard_link: data.dashboard_link,
        sort_order: data.sort_order,
    },
  })

  return response?.data
}
